import React from 'react';
import Form from 'components/Form';
import useFormikSubmit from 'hooks/useFormikSubmit';
import useAuthentication from 'modules/auth/hooks/useAuthentication';
import { FetchingStatus } from 'types/enums/FetchType';

import { Box, Button, Typography } from '@lyearn/ui';

import useForgotPasswordForm from './hooks/useForgotPasswordForm';
import Header from './FormHeader';
import Success from './SuccessMessage';

const ForgotPasswordForm = (/* props: { redirectPath?: string; handleClose?: Function } */) => {
  const { fetchStatus } = useAuthentication();
  const [formikSubmit, setFormikSubmit] = useFormikSubmit();
  const { formFields, initialValue, validate, onSubmit, passwordLinkSentStatus } =
    useForgotPasswordForm();

  if (passwordLinkSentStatus.show) {
    return <Success emailId={passwordLinkSentStatus.emailId} />;
  }

  return (
    <Box className="forgot-container mt-20 mb-50 flex flex-shrink-0 flex-col items-center">
      <Box className="mt-20 mb-50 flex flex-shrink-0 flex-col items-center">
        <Header />
        <Form
          fields={formFields}
          formName="Forgot Password"
          initialValues={initialValue}
          layout={['email']}
          setSubmitRef={setFormikSubmit}
          validate={validate}
          onSubmit={onSubmit}
        />
        <Button
          className="my-10 mt-32 w-full normal-case"
          disabled={fetchStatus === FetchingStatus.Fetching}
          variant="filled"
          onClick={formikSubmit as any}>
          <Typography variant="heading-xs">Send Password Reset Link</Typography>
        </Button>
      </Box>
    </Box>
  );
};

export default ForgotPasswordForm;
